// extracted by mini-css-extract-plugin
export var clickDisabled = "uo4NW";
export var container = "LZQXd";
export var noTextAnimation = "PBZZA";
export var saved = "umT7X";
export var showOnlyOnHover = "uHRiM";
export var starIcon = "SsIaw";
export var starIconBase = "gj8it";